export default __webpack_public_path__ + "static/diversity-inclusion-banner-e62f738ccda6243495c1e52b57f02215.png";